import React from "react";
import "./Header.scss";

export default function Header({ children, done }) {
  return (
    <div className={`header${done ? " done-loading" : ""}`}>{children}</div>
  );
}
